import { ChangeDetectorRef, Component } from '@angular/core';
import { Subject } from 'rxjs';
import { YSubscription } from 'src/extensions';

@Component({
    template: '',
    standalone: false
})
export class WatchAwareComponent {
    protected destroyed = new Subject<void>();
    protected kbsubs: { unsubscribe: Function }[] = [];
    private ysubs: YSubscription[] = [];

    constructor(protected changeDetectorRef: ChangeDetectorRef) { }

    public track(subscription: YSubscription) {
        this.ysubs.push(subscription);
        subscription.event.subscribe(() => {
            this.changeDetectorRef.detectChanges();
        });
    }

    public trackMany(subscriptions: YSubscription[]) {
        for (let sub of subscriptions) {
            this.track(sub);
        }
    }

    protected ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
        for (let subscription of this.ysubs) {
            subscription.unsubscribe();
        }
        for (let subscription of this.kbsubs) {
            subscription.unsubscribe();
        }
    }
}
